module.exports = __webpack_public_path__ + "img/logo_bci.9479ea16.png";